import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Flex } from "../../components/Flex";
import { entryActions } from "../../redux/entry/entry.slice";
import { formActions } from "../../redux/forms/form.slice";
import { permissionActions } from "../../redux/permission/permission.slice";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { thresholdActions } from "../../redux/threshold/threshold.slice";
import { userSliceSelectors } from "../../redux/user/user.selector";
import { moduleActions } from "../../redux/module/module.slice";
import { SubHeader } from "../../components/SubHeader";
import { FormDrawers } from "./FormDrawers";
import { FormsContent } from "./components/FormsContent";
import { useNavigate, useParams } from "react-router-dom";
import { formSliceSelectors } from "../../redux/forms/form.selector";
import isEmpty from "lodash/isEmpty";
import i18n from "../../i18n";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons/faArrowRight";
import last from "lodash/last";
import { EntityIcons } from "../../utils/GlobalIcons";

const FolderForms: React.FC = () => {
  const { t } = useTranslation();
  const { folderSlug } = useParams<{ folderSlug: string }>();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const folderId = last(folderSlug?.split("-"));

  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;
  const parentFolder = useAppSelector((s) =>
    formSliceSelectors.selectFolderById(s, folderId || ""),
  );

  useEffect(() => {
    dispatch(formActions.getFolders({ userId }));
    dispatch(thresholdActions.getThresholds({ userId }));
    dispatch(entryActions.getUserTableSettings({ userId }));
    dispatch(permissionActions.getMembers({ userId }));
    dispatch(moduleActions.getAllModuleDefinitions({ userId }));
  }, [dispatch, userId]);

  useEffect(() => {
    if (isEmpty(parentFolder)) {
      navigate("/forms", { replace: true });
    }
  }, [parentFolder, navigate]);

  return (
    <Fragment>
      <Flex flexDirection="column">
        <SubHeader
          title={`${t("common.forms")} / ${parentFolder?.name}`}
          icon={EntityIcons.Forms}
          actions={[
            {
              title: t("common.back"),
              icon:
                i18n.dir(i18n.language) === "ltr" ? faArrowLeft : faArrowRight,
              onClick: () => navigate("/forms"),
            },
          ]}
        />

        <FormsContent />
      </Flex>

      <FormDrawers />
    </Fragment>
  );
};

export default FolderForms;
